import React, { Component } from 'react';
import MaterialTable from '@material-table/core';

export default class VoteHistory extends Component {
    historyColumns = [
        { title: 'Пользователь', field: 'userName' },
        { title: 'Рейтинг', field: 'rate' },
    ];

    constructor(props) {
        super(props);

        this.state = {
            history: [],
            isInLoading: false
        };
    }

    componentDidMount() {
        if (!this.props.suggestionId) return;
        var scope = this;
        this.setState({ isInLoading: true });
        var token = localStorage.getItem("token");
        fetch('api/Suggestion/VoteHistory?suggestionId=' + this.props.suggestionId, {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ history: result, isInLoading: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    render() {
        if (!this.props) {
            return <div></div>
        }
        return (
            <MaterialTable
                title=""
                columns={this.historyColumns}
                
                data={this.state.history}
                editable={{
                }}
                actions={[
                ]}
            />
        );
    }
}
